import { store } from '../../store';
import { addLabTest, updateLabTest, deleteLabTest } from '../../ReduxSlices/LabTests/labTestSlice';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribeLabTests = null; // store unsubscribe function

export const initializeLabTestSubscription = () => {
  if (unsubscribeLabTests) return; // already subscribed

  // Provide a unique module key "labTests"
  unsubscribeLabTests = subscribeToCoreUpdates("labTests", {
    "lab_test.created": (data) => {
      store.dispatch(addLabTest(data));
      // console.log("new test created", data);
    },
    "lab_test.updated": (data) => {
      store.dispatch(updateLabTest(data));        
      // console.log("test updated", data);
    },
    "lab_test.deleted": (data) => {
      store.dispatch(deleteLabTest(data.id));
    }
  });

  // console.log("✅ Lab Tests subscription initialized");
};

export const unsubscribeLabTestSubscription = () => {
  if (unsubscribeLabTests) {
    unsubscribeLabTests(); // remove only Lab Tests handlers
    unsubscribeLabTests = null;
    // console.log("🔌 Lab Tests subscription removed");
  }
};